import styled from "styled-components";
import regionConfig from '../../config/regionConfig';
import React from 'react'
import { useTranslation } from 'react-i18next';
import './style.css'
import Loading from "react-loading";
import { calcularDistancia, deleteEnderecoCliente, geocodePublic } from "../../services/api";
import InputMoney from "../ListItem/InputMoney";
import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GrLocation } from "react-icons/gr";
import { RiCloseCircleLine } from "react-icons/ri";
import { updateClienteAddress } from "../../services/api";
import PhoneInput from "../../components/PhoneInput";
import { formatPhoneDisplay } from "../../utils/phone";
import {
    setDefaults,
} from "react-geocode";
import {
    LoadScript,
    Autocomplete,
} from "@react-google-maps/api";

const geocodeJson = 'https://maps.googleapis.com/maps/api/geocode/json';
// TODO: mover para variável de ambiente. Manter compatibilidade.
const REACT_APP_GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

setDefaults({
    key: process.env.REACT_APP_GOOGLE_API_KEY, // Your API key here.
    language: "pt-BR", // Default language for responses.
    region: "br", // Default region for responses.
});

const DivPedidoContainer = styled.div`
  z-index:115;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ showModalEntregaPdv }) => (showModalEntregaPdv ? 'none' : 'flex')};
  float: left;
  min-width: 100%;
  min-height: 100%;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  padding: 5px 0;
  list-style: none;
  background-color: rgba(0,0,0,0.5);
  background-clip: padding-box;
  align-items:center;
  justify-content:center;
  opacity: ${({ showModalEntregaPdv }) => (showModalEntregaPdv ? '0' : '1')};
  transition: opacity .3s ease-in-out;

  // Add keyframes for the fade-in effect
  animation: fadeIn .3s ease-in-out;
  animation-fill-mode: forwards;

  // Define the keyframes for the animation
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivPedido = styled.div`
    z-index: 120;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 480px;
    max-height: 90vh;
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
    overflow-y: auto;

    @media (max-height: 800px) {
        padding: 12px 16px;
        max-height: 88vh;
        border-radius: 12px;
    }
`;

const ModalEntregaPdv = ({
    showModalEntregaPdv,
    setShowModalEntregaPdv,
    formaEntrega,
    setFormaEntrega,
    selectedCliente,
    setSelectedCliente,
    selectedAddress,
    setSelectedAddress,
    empresa,
    valorEntrega,
    setValorEntrega,
    setSavedFormaEntrega,
    telefone,
    handleTelefoneChange,
    nomeCliente,
    handleNomeChange,
    clientes,
    handleClienteClick,
}) => {
    const { t } = useTranslation('pdv');
    const idEmpresa = empresa?.id_empresa;
    const regionType = empresa?.region_type_delivery;
    const bairros_entrega = empresa?.bairros_entrega;
    const [calculandoDistancia, setCalculandoDistancia] = useState(false);
    const [valorEntregaToAdd, setValorEntregaToAdd] = useState(null);

    const [rua, setRua] = useState("");
    const [numero, setNumero] = useState("");
    const [bairro, setBairro] = useState("");
    const [bairroEditavel, setBairroEditavel] = useState(false);
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [cep, setCep] = useState("");
    const [complemento, setComplemento] = useState("");
    const [referencia, setReferencia] = useState("");
    const [latitudeToSave, setLatitudeToSave] = useState("");
    const [longitudeToSave, setLongitudeToSave] = useState("");
    const [enderecoToEdit, setEnderecoToEdit] = useState(null);
    const [autocomplete, setAutocomplete] = useState(null);

    const calcularValorEntrega = useCallback(async (endereco) => {
        //if(carrinho.length>0 && isSearchingClient===false) {
        setCalculandoDistancia(true);
        if (regionType === "bairro") {
            // Pega o bairro do endereço
            const bairroSelecionado = endereco.bairro;

            // Busca flexível: case-insensitive, trim, e busca parcial (mesmo padrão do backend)
            const bairroNormalizado = (bairroSelecionado || '').toLowerCase().trim();
            const bairroEncontrado = bairros_entrega.find(bairro => {
                const bairroConfig = (bairro.bairro_entrega || '').toLowerCase().trim();
                return bairroConfig === bairroNormalizado ||
                       bairroConfig.includes(bairroNormalizado) ||
                       bairroNormalizado.includes(bairroConfig);
            });

            if (bairroEncontrado) {
                // Retorna o valor da entrega do bairro encontrado
                const valorEntrega = bairroEncontrado.valor_entrega;
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`Valor da entrega para ${bairroSelecionado}: ${valorEntrega}`);
                toast(t('delivery.messages.regionFound'), { autoClose: 3000, type: "success" });
                setValorEntrega(valorEntrega);
                setCalculandoDistancia(false);
                setValorEntregaToAdd(1);
                return;
            } else {
                // Caso o bairro não seja encontrado
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Bairro não encontrado no array de bairros de entrega");
                toast(t('delivery.messages.errorCalculatingDistance'), { autoClose: 4000, type: "error" });
                setCalculandoDistancia(false);
                setValorEntregaToAdd(1);
                return null;
            }
        }
        if (endereco) {
            try {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("endereco>", endereco)
                //const empresa = JSON.parse(decryptedEmpresa);            
                //let cepFormatadoEmpresa = empresa.cep.replace(/-/g, '');
                //let cepFormatadoCliente = endereco.cep.replace(/-/g, '');
                //var distanciaCalculadaKm;
                //const response = await calcularDistancia(cepFormatadoEmpresa, cepFormatadoCliente);
                let coordenadasEmpresa = {
                    lat: empresa.latitude,
                    lng: empresa.longitude
                }
                let coordenadasCliente = {
                    lat: endereco.latitude,
                    lng: endereco.longitude
                }
                var distanciaCalculadaKm;
                const response = await calcularDistancia(coordenadasEmpresa, coordenadasCliente);
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Distancia calculada>", response.data.distance)
                distanciaCalculadaKm = response.data.distance;
                // Convertendo a distanciaCalculada de km para metros
                const distanciaCalculadaMetros = distanciaCalculadaKm * 1000;
                // Ordenando os raios de entrega em ordem crescente
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(empresa);
                const raiosOrdenados = empresa.raios_entrega.sort((a, b) => a.raio_entrega - b.raio_entrega);
                // Encontrando o primeiro raio que é maior ou igual à distanciaCalculada
                const raioAdequado = raiosOrdenados.find(item => item.raio_entrega >= distanciaCalculadaMetros);
                if (!raioAdequado) {
                    !enderecoToEdit && toast(t('delivery.messages.regionNotFound'), { autoClose: 4000, type: "error" });
                    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("não atendemos essa região de entrega");
                } else {
                    //setSelectedAddressToDelivery(endereco);
                    //toast("Região encontrada, valor da entrega inserido", { autoClose: 1000, type: "success" });
                    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("VALOR DA ENTREGA>", raioAdequado.valor_entrega);
                    setValorEntrega(raioAdequado.valor_entrega);
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao calcular a distância:', error);
                toast(t('delivery.messages.errorCalculatingDistance'), { autoClose: 4000, type: "error" });
            } finally {
                // Garante que setIsSearchingClient(false) será chamado independente do resultado das operações acima
                setCalculandoDistancia(false);
                setValorEntregaToAdd(1);
            }

        } else {
            // Garantir que o estado seja atualizado mesmo se não entrar na lógica principal
            setCalculandoDistancia(false);
        }
    }, [regionType, bairros_entrega, empresa, enderecoToEdit]);

    useEffect(() => {
        setValorEntrega(0);
        if (selectedAddress && formaEntrega === "Entrega") {
            calcularValorEntrega(selectedAddress);
        }
    }, [selectedAddress, formaEntrega, setValorEntrega, calcularValorEntrega]);

    const closeModalAddObsItem = () => {
        setShowModalEntregaPdv(!showModalEntregaPdv);
        setValorEntregaToAdd(null);
    }

    const saveModalFormaEntrega = () => {
        //handleSaveObsItem();
        setShowModalEntregaPdv(!showModalEntregaPdv);
        setSavedFormaEntrega({
            formaEntrega: formaEntrega,
            valorEntrega: valorEntrega,
            selectedAddress: selectedAddress
        });
        setValorEntregaToAdd(null);
        toast(t('delivery.messages.deliveryMethodAdded'), { autoClose: 1000, type: 'success' });
    }

    const handleSelectAddress = (address) => {
        setSelectedAddress(address);
        //if(formaEntrega==="Entrega") {
        //    calcularValorEntrega(address);
        //}
    }

    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const onChange = (event, nameObject, isNumber) => {
        setValorEntrega(isNumber ? Number(event.target.value) : event.target.value);
        setValorEntregaToAdd(isNumber ? Number(event.target.value) : event.target.value);
        //formik.setFieldValue("preco", isNumber ? Number(event.target.value) : event.target.value );
    };

    /*const handleSaveAddress = () => {
    
        if(rua !== "" && numero !== "" && bairro !== "" && cidade !== "" && estado !== "" && cep !== ""){
            const addressObj = {
                rua: rua,
                numero: numero,
                bairro: bairro,
                cidade: cidade,
                estado: estado,
                cep: cep,
                complemento: complemento,
                referencia: referencia
            }

            updateClienteAddress(idEmpresa, selectedCliente.telefone, addressObj, enderecoToEdit).then((response) => {
                ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response)
                if(response.status === 200){
                    toast('Endereço salvo com sucesso!', {autoClose:5000, type: 'success'});
                    //////process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response.data.response.endereco);
                    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(response)
                    selectedCliente.endereco = response.data.response.endereco;
                    setRegisteringAddress(false);
                    ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("response.data.response.endereco>>>>>>>>>>",response.data.response.endereco)
                    if(!enderecoToEdit){
                        setSelectedAddress(response.data.response.endereco[response.data.response.endereco.length-1]);
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("O QUE TEM AQUI 11>>",response.data.response.endereco[response.data.response.endereco.length-1])
                        handleClearAddress();
                    }
                    if(enderecoToEdit) {
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("O QUE TEM AQUI @2>>",response.data.response.endereco.find(endereco => endereco._id === enderecoToEdit._id))
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("O QUE TEM AQUI 333>>",enderecoToEdit);
                        setSelectedAddress(response.data.response.endereco.find(endereco => endereco._id === enderecoToEdit._id));
                        handleClearAddress();
                    }
                } else {
                    toast('Erro ao salvar endereço!', {autoClose:5000, type: 'error'});
                }
            });
            //navigate("/finalizar-pedido", {state: {personInfoObj, addressObj}});
        } else {
            toast('Por favor, preencha todos os campos obrigatórios', {autoClose:5000, type: 'warning'});
        }
    }*/
    const handleSaveAddress = () => {
        if (rua !== "" && numero !== "" && bairro !== "" && cidade !== "" && estado !== "") {
            const addressObj = {
                rua: rua,
                numero: numero,
                bairro: bairro,
                cidade: cidade,
                estado: estado,
                cep: cep,
                complemento: complemento,
                referencia: referencia,
                latitude: latitudeToSave,
                longitude: longitudeToSave
            };

            updateClienteAddress(idEmpresa, selectedCliente.telefone, addressObj, enderecoToEdit).then((response) => {
                if (response.status === 200) {
                    //toast('Endereço salvo com sucesso!', { autoClose: 5000, type: 'success' });

                    const updatedAddresses = response.data.response.endereco;
                    selectedCliente.endereco = updatedAddresses;

                    if (!enderecoToEdit) {
                        const newAddress = updatedAddresses[updatedAddresses.length - 1];
                        setSelectedAddress(newAddress);
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Novo endereço adicionado:", newAddress);
                    } else {
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Endereço atualizado!");
                    }

                    handleClearAddress();
                } else {
                    toast(t('delivery.messages.errorSavingAddress'), { autoClose: 3000, type: 'error' });
                }
            }).catch(error => {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao atualizar endereço:", error);
                toast(t('delivery.messages.errorSavingAddress'), { autoClose: 3000, type: 'error' });
            });
        } else {
            toast(t('delivery.messages.fillRequiredFields'), { autoClose: 3000, type: 'warning' });
        }
    };

    const handleEdit = (event, enderecoToEdit) => {
        event.stopPropagation();
        setSelectedAddress(null);
        setEnderecoToEdit(enderecoToEdit);
        setRua(enderecoToEdit.rua);
        setNumero(enderecoToEdit.numero);
        setBairro(enderecoToEdit.bairro);
        setCidade(enderecoToEdit.cidade);
        setEstado(enderecoToEdit.estado);
        setCep(enderecoToEdit.cep);
        setComplemento(enderecoToEdit.complemento);
        setReferencia(enderecoToEdit.referencia);
    }

    const handleDelete = (event, id) => {
        event.stopPropagation();
        deleteEnderecoCliente(idEmpresa, selectedCliente.telefone, id).then(response => {
            if (response.status === 200) {
                //const personInfoObj = estava errado
                //personInfoObj = response.data.response;
                const personInfoObj = response.data.response;
                setSelectedCliente(personInfoObj);

                toast(t('delivery.messages.addressDeleted'), { autoClose: 1000, type: 'success' });
            }
            else {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Erro ao deletar endereço!');
            }
        });
    }

    const libraries = ["places"];

    const onLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    const onPlaceChanged = () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();

            // Pega a localização (lat, lng)
            const location = {
                lat: place.geometry?.location.lat() || 0,
                lng: place.geometry?.location.lng() || 0,
            };

            // Extrai os componentes do endereço diretamente do place
            const addressComponents = place.address_components;

            // Resetando estados para evitar informações desatualizadas
            setRua("");
            setNumero("");
            setBairro("");
            setCidade("");
            setEstado("");
            setCep("");

            // Itera sobre os componentes de endereço do autocomplete
            addressComponents.forEach(component => {
                const { long_name, short_name, types } = component;

                if (types.includes("street_number")) {
                    setNumero(long_name);
                }
                if (types.includes("route")) {
                    setRua(long_name);
                }
                if (types.includes("sublocality") || types.includes("neighborhood")) {
                    setBairro(long_name);
                }
                if (types.includes("administrative_area_level_1")) {
                    setEstado(short_name);
                }
                if (types.includes("administrative_area_level_2") || types.includes("locality")) {
                    setCidade(long_name);
                }
                if (types.includes("postal_code")) {
                    setCep(long_name);
                }
            });

            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("console>", place.formatted_address);

            // Chama a geocodificação reversa apenas se precisar de algum dado adicional com base na lat/lng
            reverseGeocode({ latitude: location.lat, longitude: location.lng });
        } else {
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Autocomplete is not loaded yet!');
        }
    };

    const reverseGeocode = ({ latitude: lat, longitude: lng }) => {
        setLatitudeToSave(lat);
        setLongitudeToSave(lng);

        // ✅ Proxy backend (a frontend key é restrita por referrer e Google
        // bloqueia esse tipo de chave em chamadas REST de Geocoding).
        geocodePublic({ latlng: `${lat},${lng}` })
            .then(response => {
                const data = response.data || {};
                const results = data.results || [];

                // Variáveis temporárias para armazenar valores
                //let numeroTemp = '';
                let ruaTemp = '';
                let bairroTemp = '';
                let cidadeTemp = '';
                let estadoTemp = '';
                let cepTemp = '';
                let cepFound = false;
                let ruaFound = false;
                let bairroFound = false;

                // process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('Resultados geocode', results);

                for (const result of results) {
                    const addressComponents = result.address_components;

                    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("addressComponents>", addressComponents);
                    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("LATITUDE E LONGITUDE:", lat, ",", lng);

                    // Coleta dados de addressComponents sem modificar o estado diretamente
                    for (const component of addressComponents) {
                        const { long_name, short_name, types } = component;

                        /*if (types.includes("street_number") && !cepFound && !ruaFound && !numeroTemp) {
                            numeroTemp = long_name;
                        }*/
                        if (types.includes("route") && !cepFound && !ruaFound && !ruaTemp) {
                            ruaTemp = long_name;
                            ruaFound = true; // Marca que uma Rua foi encontrada
                        }
                        if ((types.includes("sublocality") || types.includes("neighborhood")) && !bairroFound && !bairroTemp) {
                            bairroTemp = long_name;
                            bairroFound = true;
                            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("PASSOU AQUI? long_name:", long_name)
                        }
                        if (types.includes("administrative_area_level_1") && !cepFound && ruaFound && !estadoTemp) {
                            estadoTemp = short_name;
                        }
                        if ((types.includes("administrative_area_level_2") || types.includes("locality")) && !cepFound && ruaFound && !cidadeTemp) {
                            cidadeTemp = long_name;
                        }
                        if (types.includes("postal_code") && !cepFound && ruaFound && !cepTemp) {
                            cepTemp = long_name;
                            cepFound = true; // Marca que um CEP foi encontrado
                        }
                    }

                    // Se um CEP foi encontrado, não precisa buscar nos próximos resultados
                    if (cepFound && ruaFound && bairroFound) {
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Detalhes do endereço definidos.");
                        break; // Sai do loop uma vez que um CEP foi encontrado e as informações foram definidas
                    }
                }

                // Agora atualiza os estados, mas só para os campos que estão vazios
                setRua((prevRua) => prevRua || ruaTemp);
                //setNumero((prevNumero) => prevNumero || numeroTemp);
                setBairro((prevBairro) => prevBairro || bairroTemp);
                setCidade((prevCidade) => prevCidade || cidadeTemp);
                setEstado((prevEstado) => prevEstado || estadoTemp);
                setCep((prevCep) => prevCep || cepTemp);

                if (!cepFound && !ruaFound) {
                    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Nenhum CEP ou Rua encontrado para as coordenadas fornecidas.');
                    toast(t('delivery.messages.noCepOrStreetFound'), { autoClose: 3000, type: 'warning' });
                }
            })
            .catch(error => {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao realizar geocodificação reversa:', error);
                toast(t('delivery.messages.errorReverseGeocode'), { autoClose: 3000, type: 'error' });
            });
    };

    const handleClearAddress = () => {
        setRua("");
        setNumero("");
        setBairro("");
        setCidade("");
        setEstado("");
        setCep("");
        setComplemento("");
        setReferencia("");

        setEnderecoToEdit(null);
    }

    return (
        <DivPedidoContainer showModalEntregaPdv={showModalEntregaPdv}>
            <DivPedido>
                <div className="divModalEntregaPDV" style={{ minHeight: !formaEntrega || formaEntrega === "Retirada" ? 140 : 400 }}>
                    {calculandoDistancia && <Loading type={"spinningBubbles"} className="calculandoDistanciaModalEntrega" />}
                    <div className="divTitleAndContentModalEntregaPDV" style={{ overflowY: 'auto', maxHeight: '80vh' }}>
                        <div onClick={() => closeModalAddObsItem()} style={{
                            position: 'absolute', top: 12, right: 12, width: 28, height: 28,
                            borderRadius: 8, background: '#f1f5f9', border: '1px solid #e2e8f0',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer', transition: 'all 0.2s', zIndex: 5
                        }}>
                            <RiCloseCircleLine style={{ fontSize: 16, color: '#94a3b8' }} />
                        </div>

                        <h4>{t('delivery.formTitle')}</h4>

                        {/* Modal só abre mais pelo botão "Entrega" (Retirada agora é direta,
                            sem modal - handleSelecionarRetirada em index.jsx) - não faz
                            sentido oferecer a aba "Retirada" aqui dentro também. */}

                        {formaEntrega === "Entrega" ?
                            <>
                                <div className="divBtnCadastroEndModal">
                                    <span>{t('delivery.searchCustomer', 'Busque pelo cliente')}</span>
                                </div>
                                <div className="divEnderecoCompleto" style={{ position: 'relative' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('search.customerPhone', 'Telefone')}</label>
                                            <PhoneInput
                                                className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                onChange={handleTelefoneChange}
                                                value={telefone}
                                                placeholder={regionConfig.identity.phoneMask}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('search.customerName', 'Nome do cliente')}</label>
                                            <input
                                                type="text"
                                                value={nomeCliente}
                                                onChange={handleNomeChange}
                                                placeholder={t('search.customerName', 'Nome do cliente')}
                                                className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                    {clientes?.length > 0 && (
                                        // Mesmo componente/classe do dropdown de busca do painel principal
                                        // (customers-dropdown - position:absolute, flutua por cima). Antes
                                        // usava a classe da lista de endereços (fluxo normal, sem position),
                                        // por isso empurrava o resto do formulário pra baixo.
                                        <div className="customers-dropdown">
                                            {clientes.map(cliente => (
                                                <div
                                                    key={cliente._id}
                                                    className="customer-option"
                                                    onMouseDown={() => handleClienteClick(cliente)}
                                                >
                                                    <span className="customer-phone">{formatPhoneDisplay(cliente.telefone_completo || cliente.telefone)}</span>
                                                    <span className="customer-name">{cliente.nome}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {/* Feedback visual: só aparece depois de um cliente real escolhido no
                                    dropdown acima (selectedCliente._id só existe vindo do backend -
                                    diferencia de só ter digitado um nome livre sem selecionar nada). */}
                                {selectedCliente?._id && (
                                    selectedCliente.endereco?.length > 0 ? (
                                        <div style={{
                                            display: 'flex', alignItems: 'center', gap: 6,
                                            padding: '8px 12px', borderRadius: 8, marginTop: 8,
                                            background: 'rgba(40, 167, 69, 0.08)', color: '#1e7e34',
                                            fontSize: 13, fontWeight: 600
                                        }}>
                                            ✓ {t('delivery.addressesFound', { count: selectedCliente.endereco.length, defaultValue: `${selectedCliente.endereco.length} endereço(s) salvo(s) encontrado(s)` })}
                                        </div>
                                    ) : (
                                        <div style={{
                                            display: 'flex', alignItems: 'center', gap: 6,
                                            padding: '8px 12px', borderRadius: 8, marginTop: 8,
                                            background: 'rgba(255, 193, 7, 0.12)', color: '#8a6d00',
                                            fontSize: 13, fontWeight: 600
                                        }}>
                                            ⚠ {t('delivery.noAddressSaved', 'Nenhum endereço cadastrado para este cliente - cadastre abaixo')}
                                        </div>
                                    )
                                )}
                                <div className="divBtnCadastroEndModal">
                                    <span>{t('delivery.deliveryAddress')}</span>
                                </div>
                                {selectedCliente?.endereco?.length > 0 && !enderecoToEdit && (
                                    <div className="divEnderecosEntregaModal">
                                        {selectedCliente.endereco.map((endereco, index) => (
                                            <div key={index}
                                                className={`divEnderecoEntregaMap ${selectedAddress?._id === endereco._id ? 'selected' : ''}`}
                                                onClick={() => handleSelectAddress(endereco)}
                                            >
                                                <div style={{ width: '100%' }}>
                                                    <span>{endereco.rua} {endereco.numero}, Bairro: {endereco.bairro} - Cidade: {endereco.cidade}</span>
                                                </div>
                                                <div style={{ display: 'flex', gap: 20, paddingTop: 5 }}>
                                                    <span className="btnEditAddressModalEntrega"
                                                        onClick={(e) => handleEdit(e, endereco)}>{t('delivery.edit')}</span>
                                                    <span className="btnDeleteAddressModalEntrega"
                                                        onClick={(event) => handleDelete(event, endereco._id)}>{t('delivery.delete')}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {
                                    <div className="divAddEnderecoPadding">
                                        <span style={{ fontSize: 20, fontWeight: '700' }}>{t('delivery.addressInstructions')}</span>
                                        {
                                            regionType === "bairro" ?
                                                <div className="divEnderecoCompleto">
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.neighborhood')}</label>
                                                            <select
                                                                value={bairro}
                                                                onChange={(e) => setBairro(e.target.value)}
                                                                className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                            >
                                                                <option value="">{t('delivery.form.selectNeighborhood')}</option>
                                                                {bairros_entrega.map((bairro, index) => (
                                                                    <option key={bairro._id} value={bairro.bairro_entrega}>
                                                                        {bairro.bairro_entrega}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.street')}</label>
                                                            <input value={rua} onChange={(e) => setRua(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                placeholder={t('delivery.form.streetPlaceholder')} />
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '28%' }}>
                                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.state')}</label>
                                                            <input value={estado} onChange={(e) => setEstado(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                placeholder={t('delivery.form.statePlaceholder')} />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '68%' }}>
                                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.city')}</label>
                                                            <input value={cidade} onChange={(e) => setCidade(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                placeholder={t('delivery.form.cityPlaceholder')} />
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '28%' }}>
                                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.number')}</label>
                                                            <input value={numero} onChange={(e) => setNumero(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                placeholder={t('delivery.form.numberPlaceholder')} />
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '68%' }}>
                                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.complement')}</label>
                                                            <input value={complemento} onChange={(e) => setComplemento(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                placeholder={t('delivery.form.complementPlaceholder')} />
                                                        </div>
                                                    </div>
                                                    <div style={{ paddingTop: '10px' }}>
                                                        <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.reference')}</label>
                                                        <input value={referencia} onChange={(e) => setReferencia(e.target.value)} className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                            placeholder={t('delivery.form.referencePlaceholder')} />
                                                    </div>
                                                </div>
                                                :
                                                rua !== "" || bairro !== "" || cidade !== "" || estado !== "" ?

                                                    <div className="divEnderecoCompleto">
                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 10, alignItems: 'center', paddingBottom: 12, paddingTop: 12 }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                <GrLocation style={{ fontSize: 22, color: 'rgb(180,180,180)' }} />
                                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <span style={{ fontSize: 16, fontWeight: '600', maxWidth: '320px' }}>{rua}</span>
                                                                    <span style={{ fontSize: 15, color: 'rgb(180,180,180)', maxWidth: '320px' }}>{!bairro ? "" : `${bairro}, `}{!cidade ? "" : `${cidade} - `}{!estado ? "" : estado}</span>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <RiCloseCircleLine onClick={() => handleClearAddress()} style={{ fontSize: 22, color: 'orangered', marginRight: '10px' }} />
                                                            </div>
                                                        </div>
                                                        {/* Campo para editar o bairro, visível enquanto não preenchido */}
                                                        {bairro === "" || bairroEditavel ? (
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                                    <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.neighborhood')}</label>
                                                                    <input
                                                                        value={bairro}
                                                                        onChange={(e) => setBairro(e.target.value)}
                                                                        className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                        placeholder={t('delivery.form.neighborhoodPlaceholder')}
                                                                        onFocus={() => setBairroEditavel(true)} // Manter o input visível enquanto o usuário digita
                                                                        onBlur={() => bairro !== "" && setBairroEditavel(false)} // Ocultar o input se o bairro for preenchido
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column', width: '28%' }}>
                                                                <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.number')}</label>
                                                                <input value={numero} onChange={(e) => setNumero(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                    placeholder={t('delivery.form.numberPlaceholder')} />
                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: 'column', width: '68%' }}>
                                                                <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.complement')}</label>
                                                                <input value={complemento} onChange={(e) => setComplemento(e.target.value)} className="addressField field-input pa-3 whatsappNumberFinalizarPedidoInput"
                                                                    placeholder={t('delivery.form.complementPlaceholder')} />
                                                            </div>
                                                        </div>
                                                        <div style={{ paddingTop: '10px' }}>
                                                            <label style={{ fontSize: 14, fontWeight: '600' }}>{t('delivery.form.reference')}</label>
                                                            <input value={referencia} onChange={(e) => setReferencia(e.target.value)} className="addressField field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                                placeholder={t('delivery.form.referencePlaceholder')} />
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                        <label style={{ fontWeight: '500', fontSize: 14 }}>{t('delivery.enterAddress')}</label>
                                                        <div className="map">
                                                            <LoadScript googleMapsApiKey={REACT_APP_GOOGLE_API_KEY} libraries={libraries}>
                                                                <Autocomplete
                                                                    onLoad={onLoad}
                                                                    onPlaceChanged={onPlaceChanged}
                                                                    options={{ componentRestrictions: { country: regionConfig.identity.defaultCountry } }}
                                                                >
                                                                    <input
                                                                        className="addressField addressField-emphasis field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput"
                                                                        placeholder={t('delivery.typeAddress')}
                                                                    />
                                                                </Autocomplete>
                                                            </LoadScript>
                                                            <span className="addressField-hint">{t('delivery.addressHint', 'Digite e selecione uma das sugestões para preencher automaticamente')}</span>
                                                        </div>

                                                        {/*<div onClick={findMyLocation} className="divBtnUseLocation">
                                                <FaLocationCrosshairs />
                                                <span>{t('modals.useMyLocation')}</span>
                                            </div>
                                            */}
                                                    </>
                                        }
                                        <div className="divBtnSaveCancelModalEntrega">
                                            <button onClick={() => handleSaveAddress()}>{t('delivery.save')}</button>
                                            {enderecoToEdit && (
                                                <button onClick={() => {
                                                    setEnderecoToEdit(null);
                                                    handleClearAddress();
                                                }}>{t('delivery.cancel')}</button>
                                            )}
                                        </div>
                                    </div>
                                }


                                <div className="divValorEntregaModal">
                                    <span>{t('delivery.feeValue')}</span>
                                    <InputMoney
                                        onChange={(event) => onChange(event, 'price', true)}
                                        value={valorEntrega}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        margin="0px 0px 16px 0px"
                                        style={{
                                            outline: isFocused ? '2px solid #4070f4' : 'none',
                                            borderRadius: 10,
                                            margin: '0.6rem 0 0.2rem 0',
                                        }}
                                        className=""
                                        placeholder={t('delivery.price')}
                                    />
                                </div>


                            </>
                            : null
                        }


                    </div>

                    <div className="divBtnAddFormaEntregaModal"
                        style={{
                            background: ((formaEntrega !== 'Retirada' && !selectedAddress) || (formaEntrega !== 'Retirada' && valorEntregaToAdd === null)) ? '#bbb' : '',
                            cursor: ((formaEntrega !== 'Retirada' && !selectedAddress) || (formaEntrega !== 'Retirada' && valorEntregaToAdd === null)) ? 'not-allowed' : ''
                        }}
                    >
                        <button onClick={() => saveModalFormaEntrega()} disabled={((formaEntrega !== 'Retirada' && !selectedAddress) || (formaEntrega !== 'Retirada' && valorEntregaToAdd === null))}
                            style={{
                                background:
                                    ((formaEntrega !== 'Retirada' && !selectedAddress) || (formaEntrega !== 'Retirada' && valorEntregaToAdd === null))
                                        ? '#bbb' : '',
                                cursor:
                                    ((formaEntrega !== 'Retirada' && !selectedAddress) || (formaEntrega !== 'Retirada' && valorEntregaToAdd === null))
                                        ? 'not-allowed' : ''
                            }}
                        >
                            {t('delivery.addDeliveryMethod')}
                        </button>
                    </div>

                </div>

            </DivPedido>
        </DivPedidoContainer>
    )
}

export default ModalEntregaPdv;